import Icon from 'components/Icon';
import { TEXT_STRING } from '../../../constants';
import Rating from 'components/Rating';
import Text from 'components/Text';

type Props = {
  star?: number;
  onRedirect?: () => void;
  className?: string;
  isSalonMember?: boolean;
  isSalonPremiumMember?: boolean;
};

function ProfileRank({
  star,
  onRedirect,
  className,
  isSalonMember = false,
  isSalonPremiumMember = false,
}: Props) {
  const isSalonStyle = isSalonMember || isSalonPremiumMember;

  return (
    <div
      className={`${className} relative w-full rounded-2xl border shadow-sm ${
        isSalonStyle
          ? 'border-[#D7BA67] bg-gradient-to-br from-[#FFFDF7] to-[#FFF0C9]'
          : 'border-neutral-100 bg-[#F6F7FB]'
      } ${onRedirect ? 'cursor-pointer' : ''}`}
      onClick={onRedirect}
    >
      <div className="w-full flex justify-between items-center gap-3 p-12px">
        <div className="min-w-0 flex-1">
          <Text
            fontSize={12}
            bold
            textColor={isSalonStyle ? 'text-[#B07C13]' : 'text-neutral-400'}
          >
            {TEXT_STRING.MY_PAGE.VIP_RANK_LABEL}
          </Text>
          <Rating
            value={star}
            isBlingStar
            className="mt-8px gap-5px"
            size="w-8"
          />
        </div>

        {isSalonStyle && (
          <div className="flex items-center gap-6px shrink-0 rounded-full px-16px py-8px shadow-sm bg-gradient-to-r from-[#8B5E11] to-[#BB8A23]">
            <Icon icon="crown" width={16} height={16} color="#fac515" />
            <Text fontSize={14} textColor="text-white" bold nowrap>
              {TEXT_STRING.MY_PAGE.SALON_MEMBER}
            </Text>
          </div>
        )}
      </div>

      {isSalonStyle && (
        <div className="pointer-events-none absolute inset-0 rounded-2xl ring-1 ring-inset ring-[#F6E2A3]" />
      )}
      {!isSalonStyle && (
        <div className="pointer-events-none absolute inset-0 rounded-2xl ring-1 ring-inset ring-white/70" />
      )}
      <div className="sr-only">
        <Text fontSize={16} textColor="text-white" bold center>
          {isSalonStyle
            ? TEXT_STRING.PROFILE_RANK.SALON_RANK
            : TEXT_STRING.PROFILE_RANK.GUEST_RANK}
        </Text>
      </div>
    </div>
  );
}

export default ProfileRank;
